import React from 'react';
import { formatCurrency } from '@utils/currency';

const FreeShippingThreshold = ({ items }) => {
  const ctx = window.theme_app;
  const free_shipping_threshold = Number(ctx.getState().free_shipping_threshold || 0) * 100;
  const free_shipping_exclude_types = ctx.getState().free_shipping_exclude_types;

  // Parse exclude types string into array and normalize
  const excludedTypes = free_shipping_exclude_types
    .split(',')
    .map(type => type.trim().toLowerCase());

  // Filter eligible items
  const eligible_items = items.filter(item => {
    const itemType = item.product_type?.trim().toLowerCase() || '';
    return !excludedTypes.includes(itemType);
  });

  const excluded_items = items.filter(item => excludedTypes.includes(item.product_type?.trim().toLowerCase() || ''));
  const excluded_items_types = new Set(excluded_items.map(item => item.product_type?.trim().toLowerCase() || ''));
  
  // Format excluded types for natural language
  const formatExcludedTypesString = (types) => {
    // Apply basic pluralization and capitalize first letter
    const formattedTypes = Array.from(types).map(type => {
      const pluralized = type.endsWith('s') ? type : `${type}s`;
      return pluralized.charAt(0).toUpperCase() + pluralized.slice(1);
    });
    
    if (formattedTypes.length === 0) return '';
    if (formattedTypes.length === 1) return formattedTypes[0];
    if (formattedTypes.length === 2) return `${formattedTypes[0]} and ${formattedTypes[1]}`;
    
    // For 3+ items: "X, Y, and Z"
    const lastItem = formattedTypes.pop();
    return `${formattedTypes.join(', ')}, and ${lastItem}`;
  };
  
  const excluded_items_types_string = formatExcludedTypesString(excluded_items_types);
  const has_excluded_items = excluded_items.length > 0;
  // const verb = excluded_items_types.size === 1 ? 'is' : 'are';

  const total_price = eligible_items.reduce((acc, item) => acc + item.final_line_price, 0);

  return (
    <div className="free-shipping-threshold-bar">
      {total_price >= free_shipping_threshold ? (
        <div className="info">
          <p><strong>Success! Your order qualifies for free shipping!</strong></p>
        </div>
      ) : (
        <>
          <div className="info">
            <p>You are {formatCurrency(free_shipping_threshold - total_price)} away from free shipping</p>
          </div>
          <div className="progress-bar">
            <div className="progress-bar__fill" style={{ width: `${(total_price / free_shipping_threshold) * 100}%` }}></div>
          </div>
          {has_excluded_items && (
            <div className="excluded-items">
              <p>{excluded_items_types_string} are excluded from free shipping</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FreeShippingThreshold;
